webpackJsonp([31],{

/***/ 393:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProviderCandidate_vue__ = __webpack_require__(719);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_211aea3c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProviderCandidate_vue__ = __webpack_require__(884);
function injectStyle (ssrContext) {
  __webpack_require__(878)
}
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-211aea3c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProviderCandidate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_211aea3c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProviderCandidate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "withParams", {
  enumerable: true,
  get: function get() {
    return _withParams.default;
  }
});
exports.regex = exports.ref = exports.len = exports.req = void 0;

var _withParams = _interopRequireDefault(__webpack_require__(469));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var req = function req(value) {
  if (Array.isArray(value)) return !!value.length;

  if (value === undefined || value === null) {
    return false;
  }

  if (value === false) {
    return true;
  }

  if (value instanceof Date) {
    return !isNaN(value.getTime());
  }

  if (_typeof(value) === 'object') {
    for (var _ in value) {
      return true;
    }

    return false;
  }

  return !!String(value).length;
};

exports.req = req;

var len = function len(value) {
  if (Array.isArray(value)) return value.length;

  if (_typeof(value) === 'object') {
    return Object.keys(value).length;
  }

  return String(value).length;
};

exports.len = len;

var ref = function ref(reference, vm, parentVm) {
  return typeof reference === 'function' ? reference.call(vm, parentVm) : parentVm[reference];
};

exports.ref = ref;

var regex = function regex(type, expr) {
  return (0, _withParams.default)({
    type: type
  }, function (value) {
    return !req(value) || expr.test(value);
  });
};

exports.regex = regex;

/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "alpha", {
  enumerable: true,
  get: function get() {
    return _alpha.default;
  }
});
Object.defineProperty(exports, "alphaNum", {
  enumerable: true,
  get: function get() {
    return _alphaNum.default;
  }
});
Object.defineProperty(exports, "numeric", {
  enumerable: true,
  get: function get() {
    return _numeric.default;
  }
});
Object.defineProperty(exports, "between", {
  enumerable: true,
  get: function get() {
    return _between.default;
  }
});
Object.defineProperty(exports, "email", {
  enumerable: true,
  get: function get() {
    return _email.default;
  }
});
Object.defineProperty(exports, "ipAddress", {
  enumerable: true,
  get: function get() {
    return _ipAddress.default;
  }
});
Object.defineProperty(exports, "macAddress", {
  enumerable: true,
  get: function get() {
    return _macAddress.default;
  }
});
Object.defineProperty(exports, "maxLength", {
  enumerable: true,
  get: function get() {
    return _maxLength.default;
  }
});
Object.defineProperty(exports, "minLength", {
  enumerable: true,
  get: function get() {
    return _minLength.default;
  }
});
Object.defineProperty(exports, "required", {
  enumerable: true,
  get: function get() {
    return _required.default;
  }
});
Object.defineProperty(exports, "requiredIf", {
  enumerable: true,
  get: function get() {
    return _requiredIf.default;
  }
});
Object.defineProperty(exports, "requiredUnless", {
  enumerable: true,
  get: function get() {
    return _requiredUnless.default;
  }
});
Object.defineProperty(exports, "sameAs", {
  enumerable: true,
  get: function get() {
    return _sameAs.default;
  }
});
Object.defineProperty(exports, "url", {
  enumerable: true,
  get: function get() {
    return _url.default;
  }
});
Object.defineProperty(exports, "or", {
  enumerable: true,
  get: function get() {
    return _or.default;
  }
});
Object.defineProperty(exports, "and", {
  enumerable: true,
  get: function get() {
    return _and.default;
  }
});
Object.defineProperty(exports, "not", {
  enumerable: true,
  get: function get() {
    return _not.default;
  }
});
Object.defineProperty(exports, "minValue", {
  enumerable: true,
  get: function get() {
    return _minValue.default;
  }
});
Object.defineProperty(exports, "maxValue", {
  enumerable: true,
  get: function get() {
    return _maxValue.default;
  }
});
Object.defineProperty(exports, "integer", {
  enumerable: true,
  get: function get() {
    return _integer.default;
  }
});
Object.defineProperty(exports, "decimal", {
  enumerable: true,
  get: function get() {
    return _decimal.default;
  }
});
exports.helpers = void 0;

var _alpha = _interopRequireDefault(__webpack_require__(468));

var _alphaNum = _interopRequireDefault(__webpack_require__(471));

var _numeric = _interopRequireDefault(__webpack_require__(472));

var _between = _interopRequireDefault(__webpack_require__(473));

var _email = _interopRequireDefault(__webpack_require__(474));

var _ipAddress = _interopRequireDefault(__webpack_require__(475));

var _macAddress = _interopRequireDefault(__webpack_require__(476));

var _maxLength = _interopRequireDefault(__webpack_require__(477));

var _minLength = _interopRequireDefault(__webpack_require__(478));

var _required = _interopRequireDefault(__webpack_require__(479));

var _requiredIf = _interopRequireDefault(__webpack_require__(480));

var _requiredUnless = _interopRequireDefault(__webpack_require__(481));

var _sameAs = _interopRequireDefault(__webpack_require__(482));

var _url = _interopRequireDefault(__webpack_require__(483));

var _or = _interopRequireDefault(__webpack_require__(484));

var _and = _interopRequireDefault(__webpack_require__(485));

var _not = _interopRequireDefault(__webpack_require__(486));

var _minValue = _interopRequireDefault(__webpack_require__(487));

var _maxValue = _interopRequireDefault(__webpack_require__(488));

var _integer = _interopRequireDefault(__webpack_require__(489));

var _decimal = _interopRequireDefault(__webpack_require__(490));

var helpers = _interopRequireWildcard(__webpack_require__(465));

exports.helpers = helpers;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('alpha', /^[a-zA-Z]*$/);

exports.default = _default;

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var withParams = Object({"NODE_ENV":"production","BRAND_NAME":"Trransfer","VUE_APP_GOOGLE_MAPS_KEY":"AIzaSyDwoOCBqFXIhPMWg922paZIpeVZkudwH6I","VUE_APP_BASE_API":"https://prod-gateway-opsicar.idteknologia.net","VUE_APP_AUTH_HOST":"https://authservice.trransfer.com","VUE_APP_CDN":"https://maverick-global-assets-cp52hf.s3.ap-southeast-1.amazonaws.com","VUE_APP_GOOGLE_TAG_ID":"UA-171512499-1","VUE_APP_SUPPORT_WIDGET_ID":"51000003059","VUE_APP_SUPPORT_WIDGET_SOURCE":"https://aus-widget.freshworks.com/widgets/51000003059.js"}).BUILD === 'web' ? __webpack_require__(470).withParams : __webpack_require__(235).withParams;
var _default = withParams;
exports.default = _default;

/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withParams = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var root = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};

var fakeWithParams = function fakeWithParams(paramsOrClosure, maybeValidator) {
  if (_typeof(paramsOrClosure) === 'object' && maybeValidator !== undefined) {
    return maybeValidator;
  }

  return paramsOrClosure(function () {});
};

var withParams = root.vuelidate ? root.vuelidate.withParams : fakeWithParams;
exports.withParams = withParams;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('alphaNum', /^[a-zA-Z0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('numeric', /^[0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(min, max) {
  return (0, _common.withParams)({
    type: 'between',
    min: min,
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +min <= +value && +max >= +value;
  });
};

exports.default = _default;

/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var emailRegex = /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;

var _default = (0, _common.regex)('email', emailRegex);

exports.default = _default;

/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.withParams)({
  type: 'ipAddress'
}, function (value) {
  if (!(0, _common.req)(value)) {
    return true;
  }

  if (typeof value !== 'string') {
    return false;
  }

  var nibbles = value.split('.');
  return nibbles.length === 4 && nibbles.every(nibbleValid);
});

exports.default = _default;

var nibbleValid = function nibbleValid(nibble) {
  if (nibble.length > 3 || nibble.length === 0) {
    return false;
  }

  if (nibble[0] === '0' && nibble !== '0') {
    return false;
  }

  if (!nibble.match(/^\d+$/)) {
    return false;
  }

  var numeric = +nibble | 0;
  return numeric >= 0 && numeric <= 255;
};

/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default() {
  var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ':';
  return (0, _common.withParams)({
    type: 'macAddress'
  }, function (value) {
    if (!(0, _common.req)(value)) {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    var parts = typeof separator === 'string' && separator !== '' ? value.split(separator) : value.length === 12 || value.length === 16 ? value.match(/.{2}/g) : null;
    return parts !== null && (parts.length === 6 || parts.length === 8) && parts.every(hexValid);
  });
};

exports.default = _default;

var hexValid = function hexValid(hex) {
  return hex.toLowerCase().match(/^[0-9a-f]{2}$/);
};

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'maxLength',
    max: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) <= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'minLength',
    min: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) >= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.withParams)({
  type: 'required'
}, function (value) {
  if (typeof value === 'string') {
    return (0, _common.req)(value.trim());
  }

  return (0, _common.req)(value);
});

exports.default = _default;

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredIf',
    prop: prop
  }, function (value, parentVm) {
    return (0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredUnless',
    prop: prop
  }, function (value, parentVm) {
    return !(0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(equalTo) {
  return (0, _common.withParams)({
    type: 'sameAs',
    eq: equalTo
  }, function (value, parentVm) {
    return value === (0, _common.ref)(equalTo, this, parentVm);
  });
};

exports.default = _default;

/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var urlRegex = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

var _default = (0, _common.regex)('url', urlRegex);

exports.default = _default;

/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'or'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid || fn.apply(_this, args);
    }, false);
  });
};

exports.default = _default;

/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'and'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid && fn.apply(_this, args);
    }, true);
  });
};

exports.default = _default;

/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(validator) {
  return (0, _common.withParams)({
    type: 'not'
  }, function (value, vm) {
    return !(0, _common.req)(value) || !validator.call(this, value, vm);
  });
};

exports.default = _default;

/***/ }),

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(min) {
  return (0, _common.withParams)({
    type: 'minValue',
    min: min
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +min;
  });
};

exports.default = _default;

/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(max) {
  return (0, _common.withParams)({
    type: 'maxValue',
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value <= +max;
  });
};

exports.default = _default;

/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('integer', /(^[0-9]*$)|(^-[0-9]+$)/);

exports.default = _default;

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('decimal', /^[-]?\d*(\.\d+)?$/);

exports.default = _default;

/***/ }),

/***/ 501:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["id", "header", "content", "closeIcon", "cancelLabel", "submitLabel", "color", "icon", "subContent", "modalSize"],
  computed: {
    hasCloseIcon: function hasCloseIcon() {
      return this.closeIcon && this.closeIcon === true ? true : false;
    },
    hasCancel: function hasCancel() {
      return this.cancelLabel && this.cancelLabel !== "";
    },
    hasSubmit: function hasSubmit() {
      return this.submitLabel && this.submitLabel !== "";
    },
    getId: function getId() {
      return this.id && this.id !== "" ? this.id : "confirmmodal";
    },
    getColor: function getColor() {
      return this.color && this.color !== "" ? this.color : "confirm-icon";
    },
    getIcon: function getIcon() {
      return this.icon && this.icon !== "" ? this.icon : "ic-check";
    }
  },
  methods: {
    closeModal: function closeModal() {
      $("#" + this.getId).modal("hide");
    },
    cancel: function cancel() {
      this.$emit("onCancel");
    },
    submit: function submit() {
      $("#" + this.getId).modal("hide");
      this.$emit("submit");
    }
  }
});

/***/ }),

/***/ 509:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmModal_vue__ = __webpack_require__(501);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6af674af_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmModal_vue__ = __webpack_require__(518);
function injectStyle (ssrContext) {
  __webpack_require__(516)
}
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6af674af"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6af674af_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(517);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(384)("5636d7fe", content, true, {});

/***/ }),

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(383)(true);
// imports


// module
exports.push([module.i, ".note-content[data-v-6af674af]{font-size:13px;color:#999}.modal-header-confirm[data-v-6af674af]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;padding:15px}", "", {"version":3,"sources":["/app/src/components/shared/ConfirmModal.vue"],"names":[],"mappings":"AACA,+BACE,eAAgB,AAChB,UAAY,CACb,AACD,uCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,qBAAsB,AAClB,kBAAmB,AACf,yBAA0B,AAClC,YAAc,CACf","file":"ConfirmModal.vue","sourcesContent":["\n.note-content[data-v-6af674af] {\n  font-size: 13px;\n  color: #999;\n}\n.modal-header-confirm[data-v-6af674af] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  padding: 15px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 518:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"role":"dialog","id":_vm.getId}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalSize === 'modal-sm' ? 'modal-sm' : 'modal-xs'},[_c('div',{staticClass:"modal-content"},[(_vm.hasCloseIcon)?_c('div',{staticClass:"modal-header-confirm"},[_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){return _vm.closeModal()}}},[_c('i',{staticClass:"ic-close"})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal-body modal-confirmation"},[_c('div',{staticClass:"row text-center"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-wrapper"},[(_vm.icon === 'ic-warning')?[_c('svg',{staticClass:"warning-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 20 20"}},[_c('g',{attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"M8.686 2.852L2.127 14.777A1.5 1.5 0 0 0 3.441 17H16.56a1.5 1.5 0 0 0 1.314-2.223L11.314 2.852a1.5 1.5 0 0 0-2.628 0zM10 6.75a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75zm.75 7a.75.75 0 1 1-1.5 0a.75.75 0 0 1 1.5 0z","fill":"currentColor"}})])])]:[_c('div',{class:_vm.getColor},[_c('i',{class:_vm.getIcon})])],_vm._v(" "),_c('header',[_vm._v(_vm._s(_vm.header))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.content)}}),_vm._v(" "),(_vm.subContent)?[_c('div',{staticClass:"note-content",domProps:{"innerHTML":_vm._s(_vm.subContent)}})]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[(_vm.hasCancel)?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":_vm.cancel}},[_vm._v("\n                  "+_vm._s(_vm.cancelLabel)+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.hasSubmit)?_c('button',{staticClass:"btn btn-primary text-cap",attrs:{"type":"submit"},on:{"click":_vm.submit}},[_vm._v("\n                  "+_vm._s(_vm.submitLabel)+"\n                ")]):_vm._e()])],2)])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 599:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/vehicles';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(filter) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/list' + filter)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getAllAvailable: function getAllAvailable() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list/available').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getCommon: function getCommon() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/common').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  create: function create(request) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt('return', _context4.sent);

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  update: function update(request) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context5.abrupt('return', _context5.sent);

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  delete: function _delete(id) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint + ('/' + id)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context6.abrupt('return', _context6.sent);

            case 3:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  uploadImage: function uploadImage(request) {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/image', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context7.abrupt('return', _context7.sent);

            case 3:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  }
});

/***/ }),

/***/ 719:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_master_onboarding_ProviderCandidateDetail__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_master_onboarding_onBoardingService_js__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_master_vehicle_vehicleService_js__ = __webpack_require__(599);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    providerCandidateDetailComponent: __WEBPACK_IMPORTED_MODULE_2__components_master_onboarding_ProviderCandidateDetail__["a" /* default */]
  },
  computed: {
    isAllowToRead: function isAllowToRead() {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function isAllowToCreate() {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function isAllowToUpdate() {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function isAllowToDelete() {
      return this.allPermissions.includes("Delete");
    },
    recordInfo: function recordInfo() {
      return this.table.totalRecords > 1 ? this.table.totalRecords + " Records" : this.table.totalRecords + " Record";
    },
    userLabel: function userLabel() {
      switch (this.candidateStatus) {
        case "requested":
          return "Requested By";
        case "approved":
          return "Approved By";
        case "rejected":
          return "Rejected By";
        default:
          return null;
      }
    },
    dateLabel: function dateLabel() {
      switch (this.candidateStatus) {
        case "requested":
          return "Requested Date";
        case "approved":
          return "Approved Date";
        case "rejected":
          return "Rejected Date";
        default:
          return null;
      }
    }
  },
  data: function data() {
    return {
      table: {
        keyword: "",
        totalPages: 1,
        totalRecords: 0,
        pageNumber: 1,
        pageSize: 25,
        pageSizes: [25, 50, 100]
      },
      vehicleTypes: [],
      vehicleTransmissions: [],
      vehicleOperations: [],
      vehicleColors: [],
      allPermissions: [],
      candidateStatus: "requested",
      itemToBeDeleted: null,
      items: [],
      model: {},
      isLoading: false,
      msg: "Please wait"
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var publicSettings, profile, permissions;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.$helper.scrollTop();
              _context.next = 3;
              return _this.$store.dispatch("setting/getAllPublic");

            case 3:
              publicSettings = _context.sent;

              _this.table.pageSize = _this.$helper.extractSetting(publicSettings, "PageSize", 25);

              // subscribe message
              _this.$eventBus.$on("initializeProviderCandidate", _this.getAllRequested);

              _context.next = 8;
              return _this.$store.dispatch("user/getProfile");

            case 8:
              profile = _context.sent;
              permissions = profile.services[_this.$route.name];

              if (permissions) {
                _this.allPermissions = permissions;
              }

              if (!_this.isAllowToRead) {
                _context.next = 15;
                break;
              }

              _context.next = 14;
              return _this.getAll(_this.candidateStatus);

            case 14:
              _this.getVehicleCommon();

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  updated: function updated() {
    this.$helper.collapseMenu("onboarding");
    this.$helper.setNavigationClass("provider-candidate-link");
  },
  beforeDestroy: function beforeDestroy() {
    this.$eventBus.$off("initializeProviderCandidate");
  },

  methods: {
    onChangePageSize: function onChangePageSize() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.table.pageNumber = 1;
                _context2.next = 3;
                return _this2.getAll(_this2.candidateStatus);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    onKeyupKeyword: function onKeyupKeyword() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var self;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                self = _this3;

                if (self.timer) {
                  clearTimeout(self.timer);
                  self.timer = null;
                }
                self.timer = setTimeout(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(_) {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            self.table.pageNumber = 1;
                            _context3.next = 3;
                            return self.getAll(self.candidateStatus);

                          case 3:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this3);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }(), 500);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    },
    onNavigateCallback: function onNavigateCallback(pageNumber) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this4.table.pageNumber = pageNumber;
                _context5.next = 3;
                return _this4.getAll(_this4.candidateStatus);

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this4);
      }))();
    },
    resetTable: function resetTable() {
      this.table.keyword = "";
      this.table.pageNumber = 1;
      this.table.pageSize = 5;
    },
    resetModel: function resetModel() {
      this.model = {};
    },
    printUserAudit: function printUserAudit(item) {
      switch (this.candidateStatus) {
        case "requested":
          return item.requestedBy;
        case "approved":
          return item.approvedBy;
        case "rejected":
          return item.rejectedBy;
        default:
          return null;
      }
    },
    printDateAudit: function printDateAudit(item) {
      switch (this.candidateStatus) {
        case "requested":
          return this.printDate(item.requestedDate);
        case "approved":
          return this.printDate(item.approvedDate);
        case "rejected":
          return this.printDate(item.rejectedDate);
        default:
          return null;
      }
    },
    printDate: function printDate(item) {
      return item.year + "-" + item.stringMonth + "-" + item.stringDate + " " + item.stringHour + ":" + item.stringMinute;
    },
    getVehicleCommon: function getVehicleCommon() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var common;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4__services_master_vehicle_vehicleService_js__["a" /* default */].getCommon();

              case 2:
                common = _context6.sent;

                _this5.vehicleTypes = common.types;
                _this5.vehicleTransmissions = common.transmissions;
                _this5.vehicleOperations = common.operations;
                _this5.vehicleColors = common.colors;

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this5);
      }))();
    },
    getAll: function getAll(status) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (_this6.isAllowToRead) {
                  _context7.next = 2;
                  break;
                }

                return _context7.abrupt("return");

              case 2:
                _this6.items = [];
                _this6.candidateStatus = status;
                _context7.t0 = _this6.candidateStatus;
                _context7.next = _context7.t0 === "requested" ? 7 : _context7.t0 === "approved" ? 10 : _context7.t0 === "rejected" ? 13 : 16;
                break;

              case 7:
                _context7.next = 9;
                return _this6.getAllRequested();

              case 9:
                return _context7.abrupt("break", 16);

              case 10:
                _context7.next = 12;
                return _this6.getAllApproved();

              case 12:
                return _context7.abrupt("break", 16);

              case 13:
                _context7.next = 15;
                return _this6.getAllRejected();

              case 15:
                return _context7.abrupt("break", 16);

              case 16:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this6);
      }))();
    },
    getAllRequested: function getAllRequested() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var filter, response, index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;

                _this7.isLoading = true;
                filter = "?page=" + _this7.table.pageNumber + "&size=" + _this7.table.pageSize;

                if (_this7.table.keyword !== null && _this7.table.keyword !== "") {
                  filter += "&search=" + _this7.table.keyword;
                }
                _context8.next = 6;
                return __WEBPACK_IMPORTED_MODULE_3__services_master_onboarding_onBoardingService_js__["a" /* default */].getAllRequested(filter);

              case 6:
                response = _context8.sent;

                _this7.items = response.data;
                _this7.table.totalPages = response.totalPages;
                _this7.table.totalRecords = response.totalRecords;
                _context8.next = 15;
                break;

              case 12:
                _context8.prev = 12;
                _context8.t0 = _context8["catch"](0);

                if (_context8.t0.errors) {
                  for (index = 0; index < _context8.t0.errors.length; index++) {
                    _this7.$notification.error(_context8.t0.errors[index], { title: "Error" });
                  }
                }

              case 15:
                _context8.prev = 15;

                _this7.isLoading = false;
                return _context8.finish(15);

              case 18:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this7, [[0, 12, 15, 18]]);
      }))();
    },
    getAllApproved: function getAllApproved() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var filter, response, index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;

                _this8.isLoading = true;
                filter = "?page=" + _this8.table.pageNumber + "&size=" + _this8.table.pageSize;

                if (_this8.table.keyword !== null && _this8.table.keyword !== "") {
                  filter += "&search=" + _this8.table.keyword;
                }
                _context9.next = 6;
                return __WEBPACK_IMPORTED_MODULE_3__services_master_onboarding_onBoardingService_js__["a" /* default */].getAllApproved(filter);

              case 6:
                response = _context9.sent;

                _this8.items = response.data;
                _this8.table.totalPages = response.totalPages;
                _this8.table.totalRecords = response.totalRecords;
                _context9.next = 15;
                break;

              case 12:
                _context9.prev = 12;
                _context9.t0 = _context9["catch"](0);

                if (_context9.t0.errors) {
                  for (index = 0; index < _context9.t0.errors.length; index++) {
                    _this8.$notification.error(_context9.t0.errors[index], { title: "Error" });
                  }
                }

              case 15:
                _context9.prev = 15;

                _this8.isLoading = false;
                return _context9.finish(15);

              case 18:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this8, [[0, 12, 15, 18]]);
      }))();
    },
    getAllRejected: function getAllRejected() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var filter, response, index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;

                _this9.isLoading = true;
                filter = "?page=" + _this9.table.pageNumber + "&size=" + _this9.table.pageSize;

                if (_this9.table.keyword !== null && _this9.table.keyword !== "") {
                  filter += "&search=" + _this9.table.keyword;
                }
                _context10.next = 6;
                return __WEBPACK_IMPORTED_MODULE_3__services_master_onboarding_onBoardingService_js__["a" /* default */].getAllRejected(filter);

              case 6:
                response = _context10.sent;

                _this9.items = response.data;
                _this9.table.totalPages = response.totalPages;
                _this9.table.totalRecords = response.totalRecords;
                _context10.next = 15;
                break;

              case 12:
                _context10.prev = 12;
                _context10.t0 = _context10["catch"](0);

                if (_context10.t0.errors) {
                  for (index = 0; index < _context10.t0.errors.length; index++) {
                    _this9.$notification.error(_context10.t0.errors[index], { title: "Error" });
                  }
                }

              case 15:
                _context10.prev = 15;

                _this9.isLoading = false;
                return _context10.finish(15);

              case 18:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this9, [[0, 12, 15, 18]]);
      }))();
    },
    approve: function approve(id) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;

                _this10.isLoading = true;
                _context11.next = 4;
                return __WEBPACK_IMPORTED_MODULE_3__services_master_onboarding_onBoardingService_js__["a" /* default */].approve({
                  id: id
                });

              case 4:
                _this10.$notification.success("Successfully approved.", { title: "Success" });
                _context11.next = 7;
                return _this10.getAll(_this10.candidateStatus);

              case 7:
                _context11.next = 12;
                break;

              case 9:
                _context11.prev = 9;
                _context11.t0 = _context11["catch"](0);

                if (_context11.t0.errors) {
                  for (index = 0; index < _context11.t0.errors.length; index++) {
                    _this10.$notification.error(_context11.t0.errors[index], { title: "Error" });
                  }
                }

              case 12:
                _context11.prev = 12;

                _this10.isLoading = false;
                return _context11.finish(12);

              case 15:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this10, [[0, 9, 12, 15]]);
      }))();
    },
    reject: function reject(id) {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;

                _this11.isLoading = true;
                _context12.next = 4;
                return __WEBPACK_IMPORTED_MODULE_3__services_master_onboarding_onBoardingService_js__["a" /* default */].reject({
                  id: id
                });

              case 4:
                _this11.$notification.success("Successfully rejected.", { title: "Success" });
                _context12.next = 7;
                return _this11.getAll(_this11.candidateStatus);

              case 7:
                _context12.next = 12;
                break;

              case 9:
                _context12.prev = 9;
                _context12.t0 = _context12["catch"](0);

                if (_context12.t0.errors) {
                  for (index = 0; index < _context12.t0.errors.length; index++) {
                    _this11.$notification.error(_context12.t0.errors[index], { title: "Error" });
                  }
                }

              case 12:
                _context12.prev = 12;

                _this11.isLoading = false;
                return _context12.finish(12);

              case 15:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, _this11, [[0, 9, 12, 15]]);
      }))();
    },
    viewDetail: function viewDetail(item) {
      // publish message
      this.$eventBus.$emit("initializeProviderCandidateDetail", item.providerCandidateId, {
        vehicleTypes: this.vehicleTypes,
        vehicleTransmissions: this.vehicleTransmissions,
        vehicleOperations: this.vehicleOperations,
        vehicleColors: this.vehicleColors
      });
    },
    resendEmail: function resendEmail(id) {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3__services_master_onboarding_onBoardingService_js__["a" /* default */].resendEmail({ providerCandidateId: id });

              case 2:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, _this12);
      }))();
    },
    displayDatetime: function displayDatetime(datetime) {
      if (datetime) {
        return datetime.stringFullDate + " " + datetime.stringHour + ":" + datetime.stringMinute;
      }
    }
  }
});

/***/ }),

/***/ 720:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_ConfirmModal__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_master_onboarding_onBoardingService_js__ = __webpack_require__(721);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    confirmModal: __WEBPACK_IMPORTED_MODULE_3__components_shared_ConfirmModal__["a" /* default */]
  },
  computed: {
    isAllowToRead: function isAllowToRead() {
      return this.allPermissions.includes("Read");
    }
  },
  data: function data() {
    return {
      isSubmitted: false,
      activeTab: "provider",
      fullyApproveId: null,
      vehicleTypes: [],
      vehicleTransmissions: [],
      vehicleOperations: [],
      rejectModel: { id: null, reason: null, option: null },
      allPermissions: [],
      providerImagePreview: null,
      candidate: null,
      isLoading: false,
      msg: "Please wait"
    };
  },
  validations: function validations() {
    return {
      rejectModel: {
        reason: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["maxLength"])(300) }
      }
    };
  },
  created: function created() {
    // subscribe message
    this.$eventBus.$on("initializeProviderCandidateDetail", this.initialize);
    this.$eventBus.$on("openModalProviderCandidateDetail", this.openModal);
  },
  beforeDestroy: function beforeDestroy() {
    this.$eventBus.$off("initializeProviderCandidateDetail");
    this.$eventBus.$off("openModalProviderCandidateDetail");
    this.closeModal();
  },

  methods: {
    openModal: function openModal() {
      this.activeTab = "provider";
      $(this.$refs.providercandidatedetailmodal).modal({
        backdrop: "static",
        keyboard: false
      });
      $(this.$refs.providercandidatedetailmodal).css("overflow-y", "auto");
    },
    closeModal: function closeModal() {
      $(this.$refs.providercandidatedetailmodal).modal("hide");
    },
    resetValidation: function resetValidation() {
      this.isSubmitted = false;
      this.$v.rejectModel.$reset();
    },
    initialize: function initialize(id, common) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var profile, permissions;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.isLoading = true;

                _context.next = 4;
                return _this.$store.dispatch("user/getProfile");

              case 4:
                profile = _context.sent;
                permissions = profile.services[_this.$route.name];

                if (permissions) {
                  _this.allPermissions = permissions;
                }

                if (!_this.isAllowToRead) {
                  _context.next = 13;
                  break;
                }

                _this.vehicleTypes = common.vehicleTypes;
                _this.vehicleTransmissions = common.vehicleTransmissions;
                _this.vehicleOperations = common.vehicleOperations;
                _context.next = 13;
                return _this.getById(id);

              case 13:

                _this.openModal();

              case 14:
                _context.prev = 14;

                _this.isLoading = false;
                return _context.finish(14);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0,, 14, 17]]);
      }))();
    },
    getById: function getById(id) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4__services_master_onboarding_onBoardingService_js__["a" /* default */].getById(id);

              case 2:
                response = _context2.sent;

                _this2.candidate = response.data;
                _this2.candidate.location = _this2.candidate.location || {};
                _this2.candidate.bankConfiguration = _this2.candidate.bankConfiguration || {};
                _this2.candidate.contactPeople = _this2.candidate.contactPeople || [];
                _this2.candidate.driverCandidate = _this2.candidate.driverCandidate || {};
                _this2.candidate.vehicleCandidate = _this2.candidate.vehicleCandidate || {};

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    viewProviderDocument: function viewProviderDocument(id) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response, i;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                _this3.isLoading = true;
                _context3.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__services_master_onboarding_onBoardingService_js__["a" /* default */].viewProviderDocument(id);

              case 4:
                response = _context3.sent;

                window.open(response.data, "_blank");
                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](0);

                if (_context3.t0.errors) {
                  for (i = 0; i < _context3.t0.errors.length; i++) {
                    _this3.$notification.error(_context3.t0.errors[i], { title: "Error" });
                  }
                }

              case 11:
                _context3.prev = 11;

                _this3.isLoading = false;
                return _context3.finish(11);

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 8, 11, 14]]);
      }))();
    },
    viewDriverDocument: function viewDriverDocument(providerCandidateId, documentId) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var response, i;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                _this4.isLoading = true;
                _context4.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__services_master_onboarding_onBoardingService_js__["a" /* default */].viewDriverDocument(providerCandidateId, documentId);

              case 4:
                response = _context4.sent;

                window.open(response.data, "_blank");
                _context4.next = 11;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](0);

                if (_context4.t0.errors) {
                  for (i = 0; i < _context4.t0.errors.length; i++) {
                    _this4.$notification.error(_context4.t0.errors[i], { title: "Error" });
                  }
                }

              case 11:
                _context4.prev = 11;

                _this4.isLoading = false;
                return _context4.finish(11);

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 8, 11, 14]]);
      }))();
    },
    viewVehicleDocument: function viewVehicleDocument(providerCandidateId, documentId) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var response, i;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;

                _this5.isLoading = true;
                _context5.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__services_master_onboarding_onBoardingService_js__["a" /* default */].viewVehicleDocument(providerCandidateId, documentId);

              case 4:
                response = _context5.sent;

                window.open(response.data, "_blank");
                _context5.next = 11;
                break;

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5["catch"](0);

                if (_context5.t0.errors) {
                  for (i = 0; i < _context5.t0.errors.length; i++) {
                    _this5.$notification.error(_context5.t0.errors[i], { title: "Error" });
                  }
                }

              case 11:
                _context5.prev = 11;

                _this5.isLoading = false;
                return _context5.finish(11);

              case 14:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[0, 8, 11, 14]]);
      }))();
    },
    approveProviderDocument: function approveProviderDocument(id) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var i;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;

                _this6.isLoading = true;
                _context6.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__services_master_onboarding_onBoardingService_js__["a" /* default */].approveProviderDocument({ documentId: id });

              case 4:
                _context6.next = 6;
                return _this6.getById(_this6.candidate.providerCandidateId);

              case 6:
                _context6.next = 11;
                break;

              case 8:
                _context6.prev = 8;
                _context6.t0 = _context6["catch"](0);

                if (_context6.t0.errors) {
                  for (i = 0; i < _context6.t0.errors.length; i++) {
                    _this6.$notification.error(_context6.t0.errors[i], { title: "Error" });
                  }
                }

              case 11:
                _context6.prev = 11;

                _this6.isLoading = false;
                return _context6.finish(11);

              case 14:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this6, [[0, 8, 11, 14]]);
      }))();
    },
    approveDriverDocument: function approveDriverDocument(id) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var i;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;

                _this7.isLoading = true;
                _context7.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__services_master_onboarding_onBoardingService_js__["a" /* default */].approveDriverDocument({ documentId: id });

              case 4:
                _context7.next = 6;
                return _this7.getById(_this7.candidate.providerCandidateId);

              case 6:
                _context7.next = 11;
                break;

              case 8:
                _context7.prev = 8;
                _context7.t0 = _context7["catch"](0);

                if (_context7.t0.errors) {
                  for (i = 0; i < _context7.t0.errors.length; i++) {
                    _this7.$notification.error(_context7.t0.errors[i], { title: "Error" });
                  }
                }

              case 11:
                _context7.prev = 11;

                _this7.isLoading = false;
                return _context7.finish(11);

              case 14:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this7, [[0, 8, 11, 14]]);
      }))();
    },
    approveVehicleDocument: function approveVehicleDocument(id) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var i;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;

                _this8.isLoading = true;
                _context8.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__services_master_onboarding_onBoardingService_js__["a" /* default */].approveVehicleDocument({ documentId: id });

              case 4:
                _context8.next = 6;
                return _this8.getById(_this8.candidate.providerCandidateId);

              case 6:
                _context8.next = 11;
                break;

              case 8:
                _context8.prev = 8;
                _context8.t0 = _context8["catch"](0);

                if (_context8.t0.errors) {
                  for (i = 0; i < _context8.t0.errors.length; i++) {
                    _this8.$notification.error(_context8.t0.errors[i], { title: "Error" });
                  }
                }

              case 11:
                _context8.prev = 11;

                _this8.isLoading = false;
                return _context8.finish(11);

              case 14:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this8, [[0, 8, 11, 14]]);
      }))();
    },
    rejectProviderDocument: function rejectProviderDocument(model) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var i;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;

                _this9.isLoading = true;
                _context9.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__services_master_onboarding_onBoardingService_js__["a" /* default */].rejectProviderDocument({
                  documentId: model.id,
                  rejectedReason: model.reason
                });

              case 4:
                _context9.next = 6;
                return _this9.getById(_this9.candidate.providerCandidateId);

              case 6:
                _context9.next = 11;
                break;

              case 8:
                _context9.prev = 8;
                _context9.t0 = _context9["catch"](0);

                if (_context9.t0.errors) {
                  for (i = 0; i < _context9.t0.errors.length; i++) {
                    _this9.$notification.error(_context9.t0.errors[i], { title: "Error" });
                  }
                }

              case 11:
                _context9.prev = 11;

                _this9.isLoading = false;
                return _context9.finish(11);

              case 14:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this9, [[0, 8, 11, 14]]);
      }))();
    },
    rejectDriverDocument: function rejectDriverDocument(model) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var i;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;

                _this10.isLoading = true;
                _context10.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__services_master_onboarding_onBoardingService_js__["a" /* default */].rejectDriverDocument({
                  documentId: model.id,
                  rejectedReason: model.reason
                });

              case 4:
                _context10.next = 6;
                return _this10.getById(_this10.candidate.providerCandidateId);

              case 6:
                _context10.next = 11;
                break;

              case 8:
                _context10.prev = 8;
                _context10.t0 = _context10["catch"](0);

                if (_context10.t0.errors) {
                  for (i = 0; i < _context10.t0.errors.length; i++) {
                    _this10.$notification.error(_context10.t0.errors[i], { title: "Error" });
                  }
                }

              case 11:
                _context10.prev = 11;

                _this10.isLoading = false;
                return _context10.finish(11);

              case 14:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this10, [[0, 8, 11, 14]]);
      }))();
    },
    rejectVehicleDocument: function rejectVehicleDocument(model) {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var i;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;

                _this11.isLoading = true;
                _context11.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__services_master_onboarding_onBoardingService_js__["a" /* default */].rejectVehicleDocument({
                  documentId: model.id,
                  rejectedReason: model.reason
                });

              case 4:
                _context11.next = 6;
                return _this11.getById(_this11.candidate.providerCandidateId);

              case 6:
                _context11.next = 11;
                break;

              case 8:
                _context11.prev = 8;
                _context11.t0 = _context11["catch"](0);

                if (_context11.t0.errors) {
                  for (i = 0; i < _context11.t0.errors.length; i++) {
                    _this11.$notification.error(_context11.t0.errors[i], { title: "Error" });
                  }
                }

              case 11:
                _context11.prev = 11;

                _this11.isLoading = false;
                return _context11.finish(11);

              case 14:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this11, [[0, 8, 11, 14]]);
      }))();
    },
    openFullyApprovalDialog: function openFullyApprovalDialog(id) {
      this.fullyApproveId = id;
      $("#confirmmodal").modal({ backdrop: "static", keyboard: false });
    },
    fullyApprove: function fullyApprove() {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12() {
        var i;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;

                _this12.isLoading = true;
                _context12.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__services_master_onboarding_onBoardingService_js__["a" /* default */].fullyApprove({ providerCandidateId: _this12.fullyApproveId });

              case 4:
                _this12.closeModal();
                _this12.showNotifEmailMessageSent();
                _this12.$eventBus.$emit("initializeProviderCandidate");
                _context12.next = 12;
                break;

              case 9:
                _context12.prev = 9;
                _context12.t0 = _context12["catch"](0);

                if (_context12.t0.errors) {
                  for (i = 0; i < _context12.t0.errors.length; i++) {
                    _this12.$notification.error(_context12.t0.errors[i], { title: "Error" });
                  }
                }

              case 12:
                _context12.prev = 12;

                _this12.isLoading = false;
                return _context12.finish(12);

              case 15:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, _this12, [[0, 9, 12, 15]]);
      }))();
    },
    fullyReject: function fullyReject(model) {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13() {
        var i;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.prev = 0;

                _this13.isLoading = true;
                _context13.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__services_master_onboarding_onBoardingService_js__["a" /* default */].fullyReject({ providerCandidateId: model.id, rejectedReason: model.reason });

              case 4:
                _this13.closeModal();
                _this13.showNotifEmailMessageSent();
                _context13.next = 11;
                break;

              case 8:
                _context13.prev = 8;
                _context13.t0 = _context13["catch"](0);

                if (_context13.t0.errors) {
                  for (i = 0; i < _context13.t0.errors.length; i++) {
                    _this13.$notification.error(_context13.t0.errors[i], { title: "Error" });
                  }
                }

              case 11:
                _context13.prev = 11;

                _this13.isLoading = false;
                return _context13.finish(11);

              case 14:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, _this13, [[0, 8, 11, 14]]);
      }))();
    },
    openRejectModal: function openRejectModal(id, option) {
      this.rejectModel.id = id;
      this.rejectModel.option = option;
      this.rejectModel.reason = null;
      this.resetValidation();
      $(this.$refs.rejectmodal).modal({ backdrop: "static", keyboard: false });
    },
    closeRejectModal: function closeRejectModal() {
      this.rejectModel.id = null;
      this.rejectModel.reason = null;
      this.rejectModel.option = null;
      this.resetValidation();
      $(this.$refs.rejectmodal).modal("hide");
    },
    submitReject: function submitReject() {
      var _this14 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _this14.isSubmitted = true;
                _this14.$v.rejectModel.$touch();

                if (!_this14.$v.rejectModel.$error) {
                  _context14.next = 4;
                  break;
                }

                return _context14.abrupt("return");

              case 4:
                _context14.t0 = _this14.rejectModel.option.toLowerCase();
                _context14.next = _context14.t0 === "provider document" ? 7 : _context14.t0 === "driver document" ? 10 : _context14.t0 === "vehicle document" ? 13 : _context14.t0 === "all" ? 16 : 19;
                break;

              case 7:
                _context14.next = 9;
                return _this14.rejectProviderDocument(_this14.rejectModel);

              case 9:
                return _context14.abrupt("break", 19);

              case 10:
                _context14.next = 12;
                return _this14.rejectDriverDocument(_this14.rejectModel);

              case 12:
                return _context14.abrupt("break", 19);

              case 13:
                _context14.next = 15;
                return _this14.rejectVehicleDocument(_this14.rejectModel);

              case 15:
                return _context14.abrupt("break", 19);

              case 16:
                _context14.next = 18;
                return _this14.fullyReject(_this14.rejectModel);

              case 18:
                return _context14.abrupt("break", 19);

              case 19:
                _this14.closeRejectModal();

              case 20:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, _this14);
      }))();
    },
    sendMandatoryDocument: function sendMandatoryDocument(id) {
      var _this15 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15() {
        var i;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.prev = 0;

                _this15.isLoading = true;
                _context15.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__services_master_onboarding_onBoardingService_js__["a" /* default */].sendMandatoryDocument({ providerCandidateId: id });

              case 4:
                _context15.next = 9;
                break;

              case 6:
                _context15.prev = 6;
                _context15.t0 = _context15["catch"](0);

                if (_context15.t0.errors) {
                  for (i = 0; i < _context15.t0.errors.length; i++) {
                    _this15.$notification.error(_context15.t0.errors[i], { title: "Error" });
                  }
                }

              case 9:
                _context15.prev = 9;

                _this15.isLoading = false;
                return _context15.finish(9);

              case 12:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, _this15, [[0, 6, 9, 12]]);
      }))();
    },
    printFileSize: function printFileSize(size) {
      return this.$helper.printFileSize(size);
    },
    humanize: function humanize(value) {
      return this.$helper.humanize(value);
    },
    showNotifEmailMessageSent: function showNotifEmailMessageSent() {
      var timestamp = this.getFormattedTimestamp();
      this.$notification.success("Message have been sent to " + this.candidate.email + " at " + timestamp.time + ", " + timestamp.date + ".", { title: "Success" });
    },
    getFormattedTimestamp: function getFormattedTimestamp() {
      var dt = new Date();
      var _day = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(dt);
      var _month = new Intl.DateTimeFormat('en', { month: 'short' }).format(dt);
      var _year = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(dt);
      var _time = new Intl.DateTimeFormat('en', { hour: '2-digit', minute: '2-digit' }).format(dt);

      return {
        date: _day + " " + _month + " " + _year,
        time: _time
      };
    }
  }
});

/***/ }),

/***/ 721:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/onBoardings';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAllRequested: function getAllRequested(filter) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/list/demanded' + filter)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getAllApproved: function getAllApproved(filter) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/list/approved' + filter)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getAllRejected: function getAllRejected(filter) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/list/rejected' + filter)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  getById: function getById(candidateId) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/item/' + candidateId)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt('return', _context4.sent);

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  viewProviderDocument: function viewProviderDocument(documentId) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/item/document/provider/' + documentId)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context5.abrupt('return', _context5.sent);

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  viewDriverDocument: function viewDriverDocument(providerCandidateId, documentId) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/item/document/driver/' + providerCandidateId + '/' + documentId)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context6.abrupt('return', _context6.sent);

            case 3:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  viewVehicleDocument: function viewVehicleDocument(providerCandidateId, documentId) {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/item/document/vehicle/' + providerCandidateId + '/' + documentId)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context7.abrupt('return', _context7.sent);

            case 3:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  create: function create(request) {
    var _this8 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context8.abrupt('return', _context8.sent);

            case 3:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  },
  resendEmail: function resendEmail(request) {
    var _this9 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/email', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context9.abrupt('return', _context9.sent);

            case 3:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  },
  fullyApprove: function fullyApprove(request) {
    var _this10 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint + '/approve', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context10.abrupt('return', _context10.sent);

            case 3:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this10);
    }))();
  },
  fullyReject: function fullyReject(request) {
    var _this11 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint + '/reject', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context11.abrupt('return', _context11.sent);

            case 3:
            case 'end':
              return _context11.stop();
          }
        }
      }, _callee11, _this11);
    }))();
  },
  approveProviderDocument: function approveProviderDocument(request) {
    var _this12 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint + '/approve/provider', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context12.abrupt('return', _context12.sent);

            case 3:
            case 'end':
              return _context12.stop();
          }
        }
      }, _callee12, _this12);
    }))();
  },
  approveDriverDocument: function approveDriverDocument(request) {
    var _this13 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint + '/approve/driver', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context13.abrupt('return', _context13.sent);

            case 3:
            case 'end':
              return _context13.stop();
          }
        }
      }, _callee13, _this13);
    }))();
  },
  approveVehicleDocument: function approveVehicleDocument(request) {
    var _this14 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint + '/approve/vehicle', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context14.abrupt('return', _context14.sent);

            case 3:
            case 'end':
              return _context14.stop();
          }
        }
      }, _callee14, _this14);
    }))();
  },
  rejectProviderDocument: function rejectProviderDocument(request) {
    var _this15 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint + '/reject/provider', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context15.abrupt('return', _context15.sent);

            case 3:
            case 'end':
              return _context15.stop();
          }
        }
      }, _callee15, _this15);
    }))();
  },
  rejectDriverDocument: function rejectDriverDocument(request) {
    var _this16 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              _context16.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint + '/reject/driver', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context16.abrupt('return', _context16.sent);

            case 3:
            case 'end':
              return _context16.stop();
          }
        }
      }, _callee16, _this16);
    }))();
  },
  rejectVehicleDocument: function rejectVehicleDocument(request) {
    var _this17 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee17() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint + '/reject/vehicle', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context17.abrupt('return', _context17.sent);

            case 3:
            case 'end':
              return _context17.stop();
          }
        }
      }, _callee17, _this17);
    }))();
  },
  sendMandatoryDocument: function sendMandatoryDocument(request) {
    var _this18 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee18() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              _context18.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/email/document', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context18.abrupt('return', _context18.sent);

            case 3:
            case 'end':
              return _context18.stop();
          }
        }
      }, _callee18, _this18);
    }))();
  }
});

/***/ }),

/***/ 878:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(879);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(384)("99561bb4", content, true, {});

/***/ }),

/***/ 879:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(383)(true);
// imports


// module
exports.push([module.i, ".detail-row td[data-v-211aea3c]{height:60px}", "", {"version":3,"sources":["/app/src/components/master/onboarding/ProviderCandidate.vue"],"names":[],"mappings":"AACA,gCACE,WAAa,CACd","file":"ProviderCandidate.vue","sourcesContent":["\n.detail-row td[data-v-211aea3c] {\n  height: 60px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 880:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProviderCandidateDetail_vue__ = __webpack_require__(720);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_adfc1a2c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProviderCandidateDetail_vue__ = __webpack_require__(883);
function injectStyle (ssrContext) {
  __webpack_require__(881)
}
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProviderCandidateDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_adfc1a2c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProviderCandidateDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 881:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(882);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(384)("45f871ee", content, true, {});

/***/ }),

/***/ 882:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(383)(true);
// imports


// module
exports.push([module.i, ".candidate-status{color:#eb0011!important;font-weight:400;font-size:.8667rem}", "", {"version":3,"sources":["/app/src/components/master/onboarding/ProviderCandidateDetail.vue"],"names":[],"mappings":"AACA,kBACE,wBAA0B,AAC1B,gBAAiB,AACjB,kBAAqB,CACtB","file":"ProviderCandidateDetail.vue","sourcesContent":["\n.candidate-status {\n  color: #eb0011 !important;\n  font-weight: 400;\n  font-size: 0.8667rem;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 883:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.candidate)?_c('div',[_c('div',{ref:"providercandidatedetailmodal",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-md"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header modal-new update"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('h4',[_vm._v("On Boarding")]),_vm._v(" "),(_vm.candidate.stringModifiedDate)?_c('h6',[_vm._v("\n                Last Updated: "+_vm._s(_vm.candidate.stringModifiedDate)+"\n              ")]):_vm._e()]),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-wrapper modal-detail"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-content-body"},[_c('div',{staticClass:"row cRow"},[_c('div',{staticClass:"col-sm-12"},[_c('h4',[_vm._v("\n                      Candidates\n                      "),_c('span',{staticClass:"candidate-status"},[_vm._v("("+_vm._s(_vm.candidate.status)+")")])]),_vm._v(" "),_c('ul',{staticClass:"nav nav-tabs nav-justified tabs-mini-form",staticStyle:{"padding-bottom":"15px"}},[_c('li',{class:[_vm.activeTab === 'provider' ? 'active' : '']},[_c('a',{attrs:{"href":"#provider-candidate","data-toggle":"tab"},on:{"click":function($event){_vm.activeTab = 'provider'}}},[_c('span',[_vm._v("Provider")])])]),_vm._v(" "),_c('li',{class:[_vm.activeTab === 'driver' ? 'active' : '']},[_c('a',{attrs:{"href":"#driver-candidate","data-toggle":"tab"},on:{"click":function($event){_vm.activeTab = 'driver'}}},[_c('span',[_vm._v("Driver")])])]),_vm._v(" "),_c('li',{class:[_vm.activeTab === 'vehicle' ? 'active' : '']},[_c('a',{attrs:{"href":"#vehicle-candidate","data-toggle":"tab"},on:{"click":function($event){_vm.activeTab = 'vehicle'}}},[_c('span',[_vm._v("Vehicle")])])])]),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane fade",class:[_vm.activeTab === 'provider' ? 'in active' : ''],attrs:{"id":"provider-candidate"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.providerImagePreview),expression:"providerImagePreview"}],staticClass:"logo-provider"},[_c('img',{attrs:{"src":_vm.providerImagePreview,"alt":""}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Company Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.candidate.name),expression:"candidate.name"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.candidate.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.candidate, "name", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Company Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.candidate.email),expression:"candidate.email"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.candidate.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.candidate, "email", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Company Alternate Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.candidate.alternateEmail),expression:"candidate.alternateEmail"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.candidate.alternateEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.candidate, "alternateEmail", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('label',{staticClass:"required"},[_vm._v("Company Phone")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.candidate.phoneCode),expression:"candidate.phoneCode"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.candidate.phoneCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.candidate, "phoneCode", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.candidate.phoneNumber),expression:"candidate.phoneNumber"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.candidate.phoneNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.candidate, "phoneNumber", $event.target.value)}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('label',[_vm._v("Company Alternate Phone")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.candidate.alternatePhoneCode),expression:"candidate.alternatePhoneCode"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.candidate.alternatePhoneCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.candidate, "alternatePhoneCode", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.candidate.alternatePhoneNumber),expression:"candidate.alternatePhoneNumber"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.candidate.alternatePhoneNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.candidate, "alternatePhoneNumber", $event.target.value)}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("\n                                Operating City\n                              ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.candidate.operatingCity),expression:"candidate.operatingCity"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.candidate.operatingCity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.candidate, "operatingCity", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("\n                                Currency, Decimal & Time Format\n                              ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.candidate.regionFormatName),expression:"candidate.regionFormatName"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.candidate.regionFormatName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.candidate, "regionFormatName", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"cursor-pointer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.candidate.isSoleProprietor),expression:"candidate.isSoleProprietor"}],staticClass:"control-checkbox",attrs:{"type":"checkbox","disabled":""},domProps:{"value":_vm.candidate.isSoleProprietor,"checked":Array.isArray(_vm.candidate.isSoleProprietor)?_vm._i(_vm.candidate.isSoleProprietor,_vm.candidate.isSoleProprietor)>-1:(_vm.candidate.isSoleProprietor)},on:{"change":function($event){var $$a=_vm.candidate.isSoleProprietor,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=_vm.candidate.isSoleProprietor,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.candidate, "isSoleProprietor", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.candidate, "isSoleProprietor", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.candidate, "isSoleProprietor", $$c)}}}}),_vm._v(" "),_c('span',{staticClass:"pl-5 v-align-middle"},[_vm._v("\n                                  Is Sole Proprietor / Independent Operator\n                                ")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"cursor-pointer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.candidate.isSalesTaxApplicable),expression:"candidate.isSalesTaxApplicable"}],staticClass:"control-checkbox",attrs:{"type":"checkbox","disabled":""},domProps:{"value":_vm.candidate.isSalesTaxApplicable,"checked":Array.isArray(_vm.candidate.isSalesTaxApplicable)?_vm._i(_vm.candidate.isSalesTaxApplicable,_vm.candidate.isSalesTaxApplicable)>-1:(_vm.candidate.isSalesTaxApplicable)},on:{"change":function($event){var $$a=_vm.candidate.isSalesTaxApplicable,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=_vm.candidate.isSalesTaxApplicable,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.candidate, "isSalesTaxApplicable", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.candidate, "isSalesTaxApplicable", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.candidate, "isSalesTaxApplicable", $$c)}}}}),_vm._v(" "),_c('span',{staticClass:"pl-5 v-align-middle"},[_vm._v("\n                                  VAT/Sales Tax Applicable\n                                ")])])])])]),_vm._v(" "),(_vm.candidate.isSalesTaxApplicable)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("VAT/Sales Tax Number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.candidate.salesTaxNumber),expression:"candidate.salesTaxNumber"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.candidate.salesTaxNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.candidate, "salesTaxNumber", $event.target.value)}}})])])]):_vm._e(),_vm._v(" "),(
                            _vm.candidate.paymentMethod.toLowerCase() === 'banktransfer'
                          )?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Bank Account Owner")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.candidate.bankConfiguration.accountOwner),expression:"candidate.bankConfiguration.accountOwner"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.candidate.bankConfiguration.accountOwner)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.candidate.bankConfiguration, "accountOwner", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Bank Account Number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.candidate.bankConfiguration.accountNumber),expression:"candidate.bankConfiguration.accountNumber"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.candidate.bankConfiguration.accountNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.candidate.bankConfiguration, "accountNumber", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Bank International Account Number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(
                                    _vm.candidate.bankConfiguration
                                      .internationalAccountNumber
                                  ),expression:"\n                                    candidate.bankConfiguration\n                                      .internationalAccountNumber\n                                  "}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(
                                    _vm.candidate.bankConfiguration
                                      .internationalAccountNumber
                                  )},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.candidate.bankConfiguration
                                      , "internationalAccountNumber", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Bank Swift")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.candidate.bankConfiguration.swift),expression:"candidate.bankConfiguration.swift"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.candidate.bankConfiguration.swift)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.candidate.bankConfiguration, "swift", $event.target.value)}}})])])])]):(_vm.candidate.paymentMethod.toLowerCase() === 'paypal')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("PayPal Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.candidate.paypalConfiguration.email),expression:"candidate.paypalConfiguration.email"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.candidate.paypalConfiguration.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.candidate.paypalConfiguration, "email", $event.target.value)}}})])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Company City")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.candidate.city),expression:"candidate.city"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.candidate.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.candidate, "city", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Company Address")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.candidate.location.address),expression:"candidate.location.address"}],staticClass:"form-control",attrs:{"rows":"4","disabled":""},domProps:{"value":(_vm.candidate.location.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.candidate.location, "address", $event.target.value)}}})])])]),_vm._v(" "),(_vm.candidate.documents)?_c('div',{staticClass:"row"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"table-responsive table-p15"},[_c('table',{staticClass:"table table-hover table-fix"},[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.candidate.documents),function(item){return _c('tr',{key:item.id},[_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.printFileSize(item.size)))]),_vm._v(" "),_c('td',[_c('span',{attrs:{"data-toggle":!!item.status.toLowerCase() === 'rejected'
                                          ? 'tooltip'
                                          : false,"title":item.rejectedReason}},[_vm._v("\n                                      "+_vm._s(item.status)+"\n                                    ")])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('div',{staticClass:"button-action-wrapper"},[(item.status.toLowerCase() === 'requested')?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.approveProviderDocument(item.id)}}},[_c('span',[_vm._v("Approve")])]):_vm._e(),_vm._v(" "),(item.status.toLowerCase() === 'requested')?_c('button',{staticClass:"btn btn-default sts-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.openRejectModal(item.id, 'Provider Document')}}},[_c('span',[_vm._v("Reject")])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-default --green35",attrs:{"type":"button"},on:{"click":function($event){return _vm.viewProviderDocument(item.id)}}},[_c('span',[_vm._v("View")])])])])])}),0)])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",class:[_vm.activeTab === 'driver' ? 'in active' : ''],attrs:{"id":"driver-candidate"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Name")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.candidate.driverCandidate.title),expression:"candidate.driverCandidate.title"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.candidate.driverCandidate.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.candidate.driverCandidate, "title", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.candidate.driverCandidate.fullName),expression:"candidate.driverCandidate.fullName"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.candidate.driverCandidate.fullName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.candidate.driverCandidate, "fullName", $event.target.value)}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.candidate.driverCandidate.email),expression:"candidate.driverCandidate.email"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.candidate.driverCandidate.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.candidate.driverCandidate, "email", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Alternate Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.candidate.driverCandidate.alternateEmail),expression:"candidate.driverCandidate.alternateEmail"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.candidate.driverCandidate.alternateEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.candidate.driverCandidate, "alternateEmail", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('label',{staticClass:"required"},[_vm._v("Phone")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.candidate.driverCandidate.phoneCode),expression:"candidate.driverCandidate.phoneCode"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.candidate.driverCandidate.phoneCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.candidate.driverCandidate, "phoneCode", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.candidate.driverCandidate.phoneNumber),expression:"candidate.driverCandidate.phoneNumber"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.candidate.driverCandidate.phoneNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.candidate.driverCandidate, "phoneNumber", $event.target.value)}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('label',[_vm._v("Alternate Phone")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(
                                      _vm.candidate.driverCandidate.alternatePhoneCode
                                    ),expression:"\n                                      candidate.driverCandidate.alternatePhoneCode\n                                    "}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(
                                      _vm.candidate.driverCandidate.alternatePhoneCode
                                    )},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.candidate.driverCandidate, "alternatePhoneCode", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(
                                      _vm.candidate.driverCandidate.alternatePhoneNumber
                                    ),expression:"\n                                      candidate.driverCandidate.alternatePhoneNumber\n                                    "}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(
                                      _vm.candidate.driverCandidate.alternatePhoneNumber
                                    )},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.candidate.driverCandidate, "alternatePhoneNumber", $event.target.value)}}})])])])])]),_vm._v(" "),(
                            _vm.candidate.driverCandidate.documents &&
                            !_vm.candidate.driverCandidate.isExisting
                          )?_c('div',{staticClass:"row"},[_c('div',{staticClass:"table-responsive table-p15"},[_c('table',{staticClass:"table table-hover table-fix"},[_vm._m(3),_vm._v(" "),_c('tbody',_vm._l((_vm.candidate.driverCandidate.documents),function(item){return _c('tr',{key:item.id},[_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.printFileSize(item.size)))]),_vm._v(" "),_c('td',[_c('span',{attrs:{"data-toggle":!!item.status.toLowerCase() === 'rejected'
                                          ? 'tooltip'
                                          : false,"title":item.rejectedReason}},[_vm._v("\n                                      "+_vm._s(item.status)+"\n                                    ")])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('div',{staticClass:"button-action-wrapper"},[(item.status.toLowerCase() === 'requested')?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.approveDriverDocument(item.id)}}},[_c('span',[_vm._v("Approve")])]):_vm._e(),_vm._v(" "),(item.status.toLowerCase() === 'requested')?_c('button',{staticClass:"btn btn-default sts-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.openRejectModal(item.id, 'Driver Document')}}},[_c('span',[_vm._v("Reject")])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-default --green35",attrs:{"type":"button"},on:{"click":function($event){return _vm.viewDriverDocument(
                                            _vm.candidate.providerCandidateId,
                                            item.id
                                          )}}},[_c('span',[_vm._v("View")])])])])])}),0)])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",class:[_vm.activeTab === 'vehicle' ? 'in active' : ''],attrs:{"id":"vehicle-candidate"}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Type")]),_vm._v(" "),_c('div',{staticClass:"d-flex"},_vm._l((_vm.vehicleTypes),function(item,index){return _c('label',{key:index,staticClass:"cursor-pointer",class:{'pl-20': index > 0}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.candidate.vehicleCandidate.type),expression:"candidate.vehicleCandidate.type"}],staticClass:"control-radio",attrs:{"type":"radio","disabled":""},domProps:{"value":item.text,"checked":_vm._q(_vm.candidate.vehicleCandidate.type,item.text)},on:{"change":function($event){return _vm.$set(_vm.candidate.vehicleCandidate, "type", item.text)}}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("\n                                "+_vm._s(item.text)+"\n                              ")])])}),0)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Class")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.candidate.vehicleCandidate.className),expression:"candidate.vehicleCandidate.className"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.candidate.vehicleCandidate.className)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.candidate.vehicleCandidate, "className", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Color")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.candidate.vehicleCandidate.feature.color),expression:"candidate.vehicleCandidate.feature.color"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.candidate.vehicleCandidate.feature.color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.candidate.vehicleCandidate.feature, "color", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Manufacturer")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.candidate.vehicleCandidate.factoryName),expression:"candidate.vehicleCandidate.factoryName"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.candidate.vehicleCandidate.factoryName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.candidate.vehicleCandidate, "factoryName", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Model")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.candidate.vehicleCandidate.brandName),expression:"candidate.vehicleCandidate.brandName"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.candidate.vehicleCandidate.brandName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.candidate.vehicleCandidate, "brandName", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('label',{staticClass:"required"},[_vm._v("Plate No.")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.candidate.vehicleCandidate.plateNumber),expression:"candidate.vehicleCandidate.plateNumber"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.candidate.vehicleCandidate.plateNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.candidate.vehicleCandidate, "plateNumber", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('label',{staticClass:"required"},[_vm._v("Year Manufactured")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(
                                      _vm.candidate.vehicleCandidate.feature
                                        .yearManufactured
                                    ),expression:"\n                                      candidate.vehicleCandidate.feature\n                                        .yearManufactured\n                                    "}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(
                                      _vm.candidate.vehicleCandidate.feature
                                        .yearManufactured
                                    )},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.candidate.vehicleCandidate.feature
                                        , "yearManufactured", $event.target.value)}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"cursor-pointer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.candidate.vehicleCandidate.feature.hasAirConditioning),expression:"candidate.vehicleCandidate.feature.hasAirConditioning"}],staticClass:"control-checkbox",attrs:{"type":"checkbox","disabled":""},domProps:{"checked":Array.isArray(_vm.candidate.vehicleCandidate.feature.hasAirConditioning)?_vm._i(_vm.candidate.vehicleCandidate.feature.hasAirConditioning,null)>-1:(_vm.candidate.vehicleCandidate.feature.hasAirConditioning)},on:{"change":function($event){var $$a=_vm.candidate.vehicleCandidate.feature.hasAirConditioning,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.candidate.vehicleCandidate.feature, "hasAirConditioning", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.candidate.vehicleCandidate.feature, "hasAirConditioning", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.candidate.vehicleCandidate.feature, "hasAirConditioning", $$c)}}}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("\n                              Air Conditioning\n                            ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Operation")]),_vm._v(" "),_c('div',{staticClass:"d-flex"},_vm._l((_vm.vehicleOperations),function(item,index){return _c('label',{key:index,staticClass:"cursor-pointer",class:{'pl-20': index > 0}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.candidate.vehicleCandidate.operations),expression:"candidate.vehicleCandidate.operations"}],staticClass:"control-checkbox",attrs:{"type":"checkbox","disabled":""},domProps:{"value":item.text,"checked":Array.isArray(_vm.candidate.vehicleCandidate.operations)?_vm._i(_vm.candidate.vehicleCandidate.operations,item.text)>-1:(_vm.candidate.vehicleCandidate.operations)},on:{"change":function($event){var $$a=_vm.candidate.vehicleCandidate.operations,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=item.text,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.candidate.vehicleCandidate, "operations", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.candidate.vehicleCandidate, "operations", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.candidate.vehicleCandidate, "operations", $$c)}}}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("\n                                "+_vm._s(_vm.humanize(item.text))+"\n                              ")])])}),0)]),_vm._v(" "),(
                            _vm.candidate.vehicleCandidate.documents &&
                            !_vm.candidate.vehicleCandidate.isExisting
                          )?_c('div',{staticClass:"row"},[_c('div',{staticClass:"table-responsive table-p15"},[_c('table',{staticClass:"table table-hover table-fix"},[_vm._m(4),_vm._v(" "),_c('tbody',_vm._l((_vm.candidate.vehicleCandidate.documents),function(item){return _c('tr',{key:item.id},[_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.printFileSize(item.size)))]),_vm._v(" "),_c('td',[_c('span',{attrs:{"data-toggle":!!item.status.toLowerCase() === 'rejected'
                                          ? 'tooltip'
                                          : false,"title":item.rejectedReason}},[_vm._v("\n                                      "+_vm._s(item.status)+"\n                                    ")])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('div',{staticClass:"button-action-wrapper"},[(item.status.toLowerCase() === 'requested')?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.approveVehicleDocument(item.id)}}},[_c('span',[_vm._v("Approve")])]):_vm._e(),_vm._v(" "),(item.status.toLowerCase() === 'requested')?_c('button',{staticClass:"btn btn-default sts-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.openRejectModal(item.id, 'Vehicle Document')}}},[_c('span',[_vm._v("Reject")])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-default --green35",attrs:{"type":"button"},on:{"click":function($event){return _vm.viewVehicleDocument(
                                            _vm.candidate.providerCandidateId,
                                            item.id
                                          )}}},[_c('span',[_vm._v("View")])])])])])}),0)])])]):_vm._e()])]),_vm._v(" "),(_vm.candidate.status.toLowerCase() === 'requested')?_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.openFullyApprovalDialog(_vm.candidate.providerCandidateId)}}},[_vm._v("\n                        Approve\n                      ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default sts-danger",on:{"click":function($event){return _vm.openRejectModal(_vm.candidate.providerCandidateId, 'All')}}},[_vm._v("\n                        Reject\n                      ")])]):_vm._e()])])])])])])])])]),_vm._v(" "),_c('div',{ref:"rejectmodal",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-sm"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('h4',[_vm._v("Reject "+_vm._s(_vm.rejectModel.option))]),_vm._v(" "),_c('h6',[_vm._v("Please fill all information below.")])]),_vm._v(" "),_vm._m(5)])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-content-body"},[(_vm.$v.rejectModel.$error)?_c('div',{staticClass:"summary-error"},[_vm._v("\n                  This form has errors\n                ")]):_vm._e(),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitReject($event)}}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Reason")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.rejectModel.reason),expression:"rejectModel.reason"}],staticClass:"form-control",attrs:{"rows":"3"},domProps:{"value":(_vm.rejectModel.reason)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.rejectModel, "reason", $event.target.value)}}}),_vm._v(" "),(_vm.rejectModel.reason && _vm.rejectModel.reason !== '')?_c('div',{staticClass:"text-right word-count"},[_vm._v("\n                      "+_vm._s(_vm.rejectModel.reason.length)+" from\n                      "+_vm._s(_vm.$v.rejectModel.reason.$params.maxLength.max)+" characters\n                    ")]):_vm._e(),_vm._v(" "),(_vm.isSubmitted && _vm.$v.rejectModel.reason.$error)?_c('div',[(!_vm.$v.rejectModel.reason.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Reason is required")]):_vm._e(),_vm._v(" "),(!_vm.$v.rejectModel.reason.maxLength)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Reason must be less than\n                        "+_vm._s(_vm.$v.rejectModel.reason.$params.maxLength.max)+"\n                        characters")]):_vm._e()]):_vm._e()]),_vm._v(" "),_vm._m(6)])])])])])])])]),_vm._v(" "),_c('confirmModal',{attrs:{"header":'On Boarding',"content":'Are you sure want to approve this candidate?',"cancel-label":'Cancel',"submit-label":'Yes'},on:{"submit":_vm.fullyApprove}}),_vm._v(" "),_c('loader',{attrs:{"content":_vm.msg,"visible":_vm.isLoading}})],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('i',{staticClass:"ic-close"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-12"},[_c('label',[_vm._v("Documents ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Name")]),_vm._v(" "),_c('th',[_vm._v("Size")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Action")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Name")]),_vm._v(" "),_c('th',[_vm._v("Size")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Action")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Name")]),_vm._v(" "),_c('th',[_vm._v("Size")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Action")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('i',{staticClass:"ic-close"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer text-right"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("Submit")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 884:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"middle-content"},[_c('div',{staticClass:"container"},[(_vm.isAllowToRead)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"btn-group mb-15",attrs:{"role":"group","aria-label":"..."}},[_c('button',{staticClass:"btn btn-default",class:{ 'btn-active': _vm.candidateStatus === 'requested' },attrs:{"type":"button"},on:{"click":function($event){return _vm.getAll('requested')}}},[_vm._v("\n                Requested\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{ 'btn-active': _vm.candidateStatus === 'approved' },attrs:{"type":"button"},on:{"click":function($event){return _vm.getAll('approved')}}},[_vm._v("\n                Approved\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{ 'btn-active': _vm.candidateStatus === 'rejected' },attrs:{"type":"button"},on:{"click":function($event){return _vm.getAll('rejected')}}},[_vm._v("\n                Rejected\n              ")])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_filter"},[_c('i',{staticClass:"ic-search"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.table.keyword),expression:"table.keyword"}],staticClass:"form-control",attrs:{"type":"search","placeholder":"Search, City, Provider or Owner Name"},domProps:{"value":(_vm.table.keyword)},on:{"keyup":function($event){return _vm.onKeyupKeyword()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.table, "keyword", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_length pull-right"},[_c('label',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.table.pageSize),expression:"table.pageSize"}],staticClass:"form-control v-select",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.table, "pageSize", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.onChangePageSize()}]}},_vm._l((_vm.table.pageSizes),function(item){return _c('option',{key:item,domProps:{"value":item}},[_vm._v("\n                  "+_vm._s(item)+"\n                ")])}),0),_vm._v("\n              Entries")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"table-responsive table-p15"},[_c('table',{staticClass:"table table-hover table-fix"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Submitted Date")]),_vm._v(" "),(_vm.candidateStatus === 'approved')?_c('th',[_vm._v("Approved Date")]):_vm._e(),_vm._v(" "),(_vm.candidateStatus === 'rejected')?_c('th',[_vm._v("Rejected Date")]):_vm._e(),_vm._v(" "),_c('th',[_vm._v("Name")]),_vm._v(" "),_c('th',[_vm._v("Email")]),_vm._v(" "),_c('th',[_vm._v("City")]),_vm._v(" "),(_vm.candidateStatus === 'approved')?_c('th',[_vm._v("Email Sent?")]):_vm._e(),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Action")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item){return _c('tr',{key:item.providerCandidateId},[_c('td',[_vm._v("\n                  "+_vm._s(_vm.displayDatetime(item.createdDate))+"\n                ")]),_vm._v(" "),(_vm.candidateStatus === 'approved')?_c('td',[_vm._v("\n                  "+_vm._s(_vm.displayDatetime(item.approvedDate))+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.candidateStatus === 'rejected')?_c('td',[_vm._v("\n                  "+_vm._s(_vm.displayDatetime(item.rejectedDate))+"\n                ")]):_vm._e(),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.email))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.city))]),_vm._v(" "),(_vm.candidateStatus === 'approved')?_c('td',[_vm._v("\n                  "+_vm._s(item.isEmailSent ? "Yes" : "No")+"\n                ")]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('div',{staticClass:"button-action-wrapper"},[(_vm.candidateStatus === 'approved')?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.resendEmail(item.providerCandidateId)}}},[_c('span',[_vm._v("Email")])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.viewDetail(item)}}},[_c('span',[_vm._v("View")])])])])])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"dataTables_info --blue25"},[_c('strong',[_vm._v(_vm._s(_vm.recordInfo))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('nav',{attrs:{"aria-label":"..."}},[_c('paginate',{attrs:{"page-count":_vm.table.totalPages,"click-handler":_vm.onNavigateCallback,"prev-text":'Previous',"next-text":'Next',"container-class":'pagination pull-right'},model:{value:(_vm.table.pageNumber),callback:function ($$v) {_vm.$set(_vm.table, "pageNumber", $$v)},expression:"table.pageNumber"}})],1)])])])]),_vm._v(" "),_c('div',[_c('providerCandidateDetailComponent')],1),_vm._v(" "),_c('loader',{attrs:{"content":_vm.msg,"visible":_vm.isLoading}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section-header-info"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('nav',{attrs:{"aria-label":"breadcrumb"}},[_c('ol',{staticClass:"breadcrumb"},[_c('li',{staticClass:"breadcrumb-item"},[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Onboarding")])]),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active",attrs:{"aria-current":"page"}},[_vm._v("Candidate")])])]),_vm._v(" "),_c('div',{staticClass:"content-header-info"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"pull-left"},[_c('h2',[_vm._v("\n                  Provider Candidate "),_c('span',[_c('i',{staticClass:"ic-manage-access"})])]),_vm._v(" "),_c('p',[_vm._v("Manage your provider, driver and vehicle candidate.")])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/31.d9c1b4cc64e5d1e40b54.js